// extracted by mini-css-extract-plugin
export default {"container":"CallSession_container__ijWzp"};